export const getCroppedImg = (
    imageSrc,
    pixelCrop
  ) =>
    new Promise((resolve) => {
      const image = new Image();
  
      image.src = imageSrc;
  
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
  
        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );
  
        canvas.toBlob((blob) => {
          const file = new File(
            [blob],
            "profile.jpg",
            { type: "image/jpeg" }
          );
  
          resolve(file);
        }, "image/jpeg");
      };
    });